export default __webpack_public_path__ + "static/pulzion19-e1e37f52d14b3950687a5583648ff724.png";